import { debounce } from 'lodash'
import slideApi from '@/api/slide'
import { PARTICIPANT_SELECTED_FIELDS } from '@/vuex/modules/presentation/setting.module'

const SELECT_PARTICIPANT_FIELDS_NAME = 'selectedParticipantFields'
let debouncedUpdateParticipantField = null

const actions = {
  updateSelectedParticipantFields: async ({ commit }, { slideId, fields }) => {
    // update code go here
    // Update local slide active state
    commit('updateSlideById', {
      id: slideId,
      [PARTICIPANT_SELECTED_FIELDS]: fields,
    }, { root: true })

    // Call Api
    if (!debouncedUpdateParticipantField) {
      debouncedUpdateParticipantField = debounce(
        // We need to bind everytime, otherwise, it will catch the wrong value
        // eslint-disable-next-line no-shadow
        (slideId, fields) => {
          slideApi.updateSelectedParticipantFields(slideId, {
            selectedParticipantFields: fields,
          })
        },
        300,
      )
    }

    return debouncedUpdateParticipantField(slideId, fields)
  },
  deleteSlideParticipantField: async ({ dispatch }, { slide, fieldId }) => {
    const { selectedParticipantFields } = slide
    if (!selectedParticipantFields || !selectedParticipantFields.length) return
    const updatedFields = selectedParticipantFields?.filter((f) => f.id !== fieldId)

    dispatch('updateSelectedParticipantFields', {
      slideId: slide?.id,
      fields: updatedFields,
    })
  },
}

const _getters = {
  selectedParticipantFields: (_, __, ___, rootGetters) => {
    const participantFields = rootGetters['presentationSetting/participantFields']
    const selectedFields = rootGetters['slideModule/slideActive'][SELECT_PARTICIPANT_FIELDS_NAME] || []

    return selectedFields?.map(({ id, required, hidden }) => {
      const fieldData = participantFields?.find(({ id: fieldId }) => fieldId === id)
      return {
        ...fieldData,
        id,
        required,
        hidden,
      }
    })
  },
}

export default {
  namespaced: true,
  actions,
  getters: _getters,
}
